var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{ref:"apexChart",attrs:{"height":250,"type":"radar","series":[{
      name: `${_vm.graphData.field_name}`,
      data: [..._vm.graphData.series]
    }],"options":{
    chart: {
      id: `vuechart-${_vm.graph.id}`,
      zoom: {
        enabled: false
      },
      toolbar: {
        show: true,
        export: {
          csv: {
            filename: `${_vm.graph.name}`
          },
          svg: {
            filename: `${_vm.graph.name}`
          },
          png: {
            filename: `${_vm.graph.name}`
          }
        }
      }
    },
    colors: [_vm.chartColor],
    xaxis: {
      categories: [..._vm.graphData.labels]
    }
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }